package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class BookingDto(
    val id: String,
    val clubId: String,
    val fieldId: String,
    val fieldName: String? = null,
    val userId: String,
    val userName: String? = null,
    val userAvatarUrl: String? = null,
    val bookingDate: String,
    val startTime: String,
    val endTime: String,
    val status: String,
    val totalPrice: String,
    val isPaid: Boolean = false,
    val note: String? = null,
    val services: List<BookingServiceDto>? = null
)

@Serializable
data class BookingServiceDto(
    val id: String,
    val serviceId: String,
    val quantity: Int,
    val priceAtBooking: String
)

@Serializable
data class CreateBookingRequest(
    val clubId: String,
    val fieldId: String,
    val bookingDate: String,
    val startTime: String,
    val endTime: String,
    val note: String? = null,
    val services: List<BookingServiceEntry>? = null
)

@Serializable
data class EditBookingRequest(
    val fieldId: String? = null,
    val bookingDate: String? = null,
    val startTime: String? = null,
    val endTime: String? = null,
    val totalPrice: String? = null,
    val note: String? = null
)

@Serializable
data class BookingServiceEntry(
    val serviceId: String,
    val quantity: Int = 1
)

@Serializable
data class AdminCreateBookingRequest(
    val userId: String,
    val fieldId: String,
    val bookingDate: String,
    val startTime: String,
    val endTime: String,
    val note: String? = null,
    val services: List<BookingServiceEntry>? = null
)

@Serializable
data class BookingHistoryPageDto(
    val bookings: List<BookingDto>,
    val total: Long,
    val page: Int,
    val size: Int
)

@Serializable
data class BookingCalendarDto(
    val weekStart: String,
    val days: List<CalendarDayDto>
)

@Serializable
data class CalendarDayDto(
    val date: String,
    val bookings: List<BookingDto>
)
